import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import Navigation from './components/feature/Navigation';
import Footer from './components/feature/Footer';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <div className="min-h-screen bg-black">
        <Navigation />
        <AppRoutes />
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
